// extracted by mini-css-extract-plugin
export default {"container":"Statement_container__2khe2"};